<div class="subBlockContainer">
  <div class="subBlockContent" id="manageAMPSubscription">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <loading-screen *ngIf="loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <form [formGroup]="ampManageSubForm">
            <!-- subscription details -->
            <ng-container>
              <div class="my-4">
                <h6>SUBSCRIPTION DETAILS</h6>
                <div class="my-4">
                  <div class="my-2" *ngIf="subscriptionTableView?.out_stk_description">
                    DESC :<span class="red-bold">
                      {{subscriptionTableView?.out_stk_description}}</span>
                  </div>
    
                  <div class="my-2" *ngIf="subscriptionTableView?.out_stock_code">
                    STOCKCODE :<span class="red-bold"> {{subscriptionTableView?.out_stock_code}}</span> <br>
                  </div>

                      
                  <div class="my-2" *ngIf="detail?.currentQuantity">
                    CURRENT QUANTITY :<span class="red-bold"> {{detail?.currentQuantity}}</span> <br>
                  </div>
    
                  <div class="my-2" *ngIf="detail?.usedQuantity">
                    USED QUANTITY :<span class="red-bold"> {{detail?.usedQuantity}} </span> <br>
                  </div>

                  <div class="my-2" *ngIf="detail?.status">
                    STATUS :<span class="red-bold"> {{ getStatus(detail?.status)}} </span> <br>
                  </div>

                  <div class="my-2">
                    <span>ADD LICENSES (QTY):&nbsp;&nbsp;&nbsp;</span>
                    <input
                      type="number"
                      aria-label="Number"
                      formControlName="addLicensesQty"
                      integerOnly
                    >
                    &nbsp;&nbsp;&nbsp;
                    <button
                      [disabled]="isAddingLicense || !authService?.currentUserHasPurchaseAccess()"
                      [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
                      matTooltip="Requires Purchasing Permissions"
                      class="button button-red button-small"
                      (click)="addLicenses()"
                      >Add
                    </button>
                    <mat-spinner
                      *ngIf="isAddingLicense"
                      mode="indeterminate" class="circle" diameter="20"
                      style="position: relative; margin-left: 25px; display: unset;" 
                    >
                    </mat-spinner>
                  </div>
    
                </div>
              </div>
              <hr>
            </ng-container>

            <!-- manage renewal -->
            <ng-container>
              <h6>MANAGE RENEWAL</h6>
              <!-- <div>
                <span class="red-bold">This subscription is being actively renewed. Updating auto renew, scheduling changes, and suspending is not available. All other actions will continue to work normally. Subscriptions may take up to 24 hours to complete their renewal</span>
              </div> -->
              <div class="row">
                <!-- left col -->
                <div class="col-md-6">
                  <div class="my-4">
                    <!-- <span>
                      Quantity increase and Upgrade will be effective instantly
                    </span> -->
                  </div>
    
                  <div class="my-4">

                    <div class="my-3">
                      <span class="highlight-text ">Subscriptions will auto-renew on the next Anniversary Date </span> <span>{{getAutoRenwewalDate()}}</span>
                    </div>
                    <div class="my-3">
                      <span class="highlight-text">Any changes need to be made at least 3 days prior to the Anniversary Date</span>
                    </div>
                    <div *ngIf="is3YC()" class="my-3">
                      <span class="highlight-text">Auto-renew can only be turned off in the 3rd year of the 3YC commitment</span>
                    </div>
    
                    <div style="display: inline-flex;">
                      <span class="highlight-text">AUTORENEW: </span>
   
                      <mat-slide-toggle
                        [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
                        matTooltip="Requires Purchasing Permissions"
                        style="margin-top: -4px;"
                        formControlName="autoRenewalEnabled"
                        (change)="toggleAutoRenew($event)"
                        class="activesuspend mx-4">
                      </mat-slide-toggle>

                      <!-- <div style="position: relative; bottom: 4px; margin-right: 10px;">
                        <mat-icon matSuffix
                          class="editmpnidicon"
                          [matTooltipPosition]="'above'"
                          matTooltip="Any changes to Autorenewal should be made at least 3 days prior to the renewal date."
                        >info</mat-icon>
                      </div>  -->
      
                      <span *ngIf="isRenewLoaded">{{getAutoRenwewalText(ampManageSubForm.get('autoRenewalEnabled').value)}}</span>
                    
                      <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                        class="circle cSPCustomerEntitlements-loading" diameter="20"
                        *ngIf="autoRenewLoading || !isRenewLoaded">
                      </mat-spinner>
                    </div>
                  </div>
    
                  <!-- QUANTITY-->
                  <div class="my-4">
    
                    <div>
                      <span> <span class="highlight-text">QUANTITY: </span> CURRENT : {{currentQty}}</span>
                    </div>
    
                    <ng-container *ngIf="ampManageSubForm.get('autoRenewalEnabled').value">
                      <div class="my-2">
                        <span>SCHEDULE QTY CHANGES TO: </span>
                      </div>
        
                      <div class="my-2">
                        <div>
                          <input
                            type="number"
                            aria-label="Number"
                            formControlName="toQty"
                            (keypress)="onQtyTyping($event)"
                            (blur)="updateQty()"
                            integerOnly
                          >
                        </div>
                        <!-- <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                          *ngIf="qtyLoading">
                        </mat-spinner> -->
                      </div>
                    </ng-container>

                  </div>
                </div>
                <!-- right col -->
                <div class="col-md-6">

                </div>
              </div>
              <hr>
            </ng-container>

            <ng-container>
              <h6>CANCELLATION</h6>

              <div>
                <span class="highlight-text"> Cancel orders that are within the 14 day grace period</span>
              </div>
   
              <div class="row">
                <div class="mt-4" style="display: flex;justify-content: center;">
                  <button
                    [disabled]="!isCanceling && !authService?.currentUserHasPurchaseAccess()"
                    [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
                    matTooltip="Requires Purchasing Permissions"
                    class="button button-red button-large"
                    (click)="navToCancelPage()"
                    >Eligible Order List
                  </button>
                  <mat-spinner
                    *ngIf="isCanceling"
                    mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                    style="position: relative;top:15px" 
                  >
                  </mat-spinner>
                </div>
              </div>
  
            </ng-container>



            <!-- UPGRADE OPTIONS -->
            <!-- <ng-container>

              <hr>

              <div class="my-4">
                <h6>UPGRADE OPTIONS</h6>
              </div>


              <div class="mt-4">
                <div *ngIf="loadingTransitionEligibilities" >
                  <mat-spinner mode="indeterminate" diameter="20" style="margin:0 auto;"></mat-spinner>
                </div>
                <div *ngIf="!loadingTransitionEligibilities">

                  <div *ngIf="!transitionEligibilitiesLoaded" class="mt-4" style="display: flex;justify-content: center;">
                    <button
                      class="button button-red button-large"
                      (click)="getTransitionEligibilities()"
                    >
                      View Eligible Offers
                    </button>
                  </div>

                  <div *ngIf="transitionEligibilitiesLoaded">
                    <label class="noData-wrapper" *ngIf="transitionEligibilitiesFilters.length == 0">
                      We couldn’t find any transition eligibilities
                    </label>
      
                    <div *ngIf="transitionEligibilitiesFilters?.length" class="mt-4">
      
      
                      <div class="table-header-allign addaddon-table">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" class="align-left" style="width: 30%;">Stock Code</th>
                              <th scope="col" class="align-left" style="width: 30%;">Title</th>
                              <th style="width: 20%;"></th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                      <div class="child-body addaddon-table">
                        <table class="table">
                          <thead hidden="true">
                            <tr>
                              <th scope="col" class="align-left" style="width: 30%;">Stock Code</th>
                              <th scope="col" class="align-left" style="width: 30%;">Title</th>
                              <th style="width: 20%;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let transition of transitionEligibilitiesFilters">
                              <tr>
                                <td style="width: 30%;">
                                  <span class="description-popup">{{transition?.catalogItemId | cspTransitionSkuPipe}}</span>
                                </td>
                                <td style="width: 30%;">
                                  <span class="description-popup">{{transition?.title}}</span>
                                </td>
                                <td style="width: 20%;" class="text-center">
                                  <button class="button button-red button-mid confirmbutton" [disabled]="isSubInProgress()"
                                    (click)="confirmTransition(transition)">Upgrade</button>
                                </td>
                              </tr>
                            </ng-container>
      
                          </tbody>
                        </table>
                      </div>
                      <div class="button-center">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container> -->

          </form>
        </div>

      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
